// File generated by PostBuildApiClientController
import { HttpApiClient } from "./HttpApiClient";
import { HttpApiRequestOptions } from "./HttpApiRequestOptions";
import { Injectable } from "@angular/core";
import { ClientDto } from "../dtos/ClientDto";
import { PagedResultDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedResultDto";
import { ClientFiltersDto } from "../dtos/ClientFiltersDto";
import { PagedSearchDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto";
import { SuggestResultDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/SuggestResultDto";
import { SuggestSearchDto } from "../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/SuggestSearchDto";

@Injectable({providedIn: 'root'})
export class ApiAdminClient {
  constructor(private _httpApiClient: HttpApiClient) {
    // Empty constructor
  }

  create(
    clientDto: ClientDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientDto> {
    return this._httpApiClient.post("/admin/client", clientDto, httpApiRequestOptions);
  }

  edit(
    clientDto: ClientDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientDto> {
    return this._httpApiClient.put("/admin/client", clientDto, httpApiRequestOptions);
  }

  getById(
    id: string,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientDto> {
    return this._httpApiClient.get("/admin/client/" + id, httpApiRequestOptions);
  }

  getDefault(httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientDto> {
    return this._httpApiClient.get("/admin/client/get-default", httpApiRequestOptions);
  }

  getPaged(
    filters: PagedSearchDto<ClientFiltersDto>,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<PagedResultDto<ClientDto>> {
    return this._httpApiClient.post("/admin/client/paged", filters, httpApiRequestOptions);
  }

  suggest(
    clientFilterDto: SuggestSearchDto<ClientFiltersDto>,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<SuggestResultDto<ClientDto>> {
    return this._httpApiClient.post("/admin/client/suggest", clientFilterDto, httpApiRequestOptions);
  }

  testWebHook(
    clientDto: ClientDto,
    httpApiRequestOptions?:HttpApiRequestOptions
  ): Promise<ClientDto> {
    return this._httpApiClient.post("/admin/client/test-webhook", clientDto, httpApiRequestOptions);
  }

}
